import React from 'react';
import propTypes from 'prop-types';

import Details from './Details';
import ProfilePicture from './ProfilePicture';
import ShareProfile from './ShareProfile';
import SocialProfiles from './SocialProfiles';
import ToggleProfile from './ToggleProfile';

function ProfileSidebar({
  userDetails, socialProfiles, profileLink, profileACL,
}) {
  const resumeLink = new URL('resume', profileLink);
  const { avatar, profile_page_hidden: profilePageHidden } = userDetails;
  return (
    <div className="profile-sidebar">
      <div className="profile-sidebar__picture-container">
        <ProfilePicture avatar={avatar} />
        { profileACL.showShareButton() ? <ShareProfile link={profileLink} />
          : null}
      </div>
      <Details {...userDetails} resumeLink={resumeLink} />
      <SocialProfiles profiles={socialProfiles} />
      { profileACL.isPrivate()
        ? <ToggleProfile defaultOpen={!profilePageHidden} />
        : null}
    </div>
  );
}

ProfileSidebar.propTypes = {
  userDetails: propTypes.object.isRequired,
  socialProfiles: propTypes.object.isRequired,
};

export default ProfileSidebar;
export { default as ProfilePicture } from './ProfilePicture';
export { default as SocialProfile } from './SocialProfiles';
export { default as Details } from './Details';
export { default as ToggleProfile } from './ToggleProfile';
